(function () {
  'use strict';

  angular
    .module('app.core')
    .run(appRun);

  appRun.$inject = ['$rootScope', '$state', '$stateParams', '$window', '$templateCache', '$q', '$api', '$translate', '$location', 'Colors', 'MainPreloader'];

  function appRun($rootScope, $state, $stateParams, $window, $templateCache, $q, $api, $translate, $location, Colors, MainPreloader) {
    // Set reference to access them from any scope
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.$storage = $window.localStorage;
    $rootScope.tableConfigForSocketModelChanged = null;

    // Uncomment this to disable template cache
    /* $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            if (typeof(toState) !== 'undefined'){
              $templateCache.remove(toState.templateUrl);
            }
        });*/

    // Allows to use branding color with interpolation
    // {{ colorByName('primary') }}
    $rootScope.colorByName = Colors.byName;

    // cancel click event easily
    $rootScope.cancel = function ($event) {
      $event.stopPropagation();
    };

    // Hooks Example
    // -----------------------------------

    // Hook not found
    $rootScope.$on('$stateNotFound',
      function (event, unfoundState /* , fromState, fromParams*/ ) {
        console.log(unfoundState.to); // "lazy.state"
        console.log(unfoundState.toParams); // {a:1, b:2}
        console.log(unfoundState.options); // {inherit:false} + default options
      });
    // Hook error
    $rootScope.$on('$stateChangeError',
      function (event, toState, toParams, fromState, fromParams, error) {
        console.log(error);
      });
    // Hook success
    $rootScope.$on('$stateChangeSuccess',
      function ( /* event, toState, toParams, fromState, fromParams*/ ) {
        // display new view from top
        $window.scrollTo(0, 0);
        // Save the route title
        $rootScope.appSubTitle = $state.current.title;

        setAppTitle();
      });

    // Load a title dynamically
    $rootScope.appMainTitle = '';
    $rootScope.appSubTitle = '';
    $rootScope.appTitle = '';

    function setAppTitle() {
      $rootScope.appTitle = $rootScope.appMainTitle + ($rootScope.appSubTitle !== '' ? ' - ' + $translate.instant($rootScope.appSubTitle) : '');
      document.title = $rootScope.appTitle;
    }

    $rootScope.getAppConfig = function () {
      return new Promise(function (resolve, reject) {
        $api.getAppConfig().then(function (response) {
          $rootScope.appConfig = response.data;

          if ($rootScope.appConfig) {
            var user = $rootScope.appConfig.user;

            Raven.setUserContext({
              id: user.id,
              email: user.email,
              name: user.name,
              active: user.active,
              permissions: $rootScope.appConfig.userPermissions
            });

            if ($window.$crisp) {
              $window.$crisp.push(['set', 'user:email', [user.email]]);
              $window.$crisp.push(['set', 'user:nickname', [user.name]]);
            }
          }

          $rootScope.appMainTitle = $rootScope.appConfig ? $rootScope.appConfig.appName : '';

          resolve($rootScope.appConfig);
        }, reject);
      });
    };

    $rootScope.helpers = {
      emptyPromise: function (item) {
        return new Promise(function (resolve) {
          resolve(item);
        });
      },
      promiseSequence: function (chain) {
        var index = 0;

        return new Promise(function (resolve, reject) {
          function next() {
            if (index < chain.length) {
              chain[index++]().then(next, reject);
            } else {
              resolve();
            }
          }

          next();
        });
      },
      defaultGetData: function (tableConfig) {
        var canceller = $q.defer();

        var promise = new Promise(function (resolve, reject) {
          try {
            var getDataParams = angular.copy(tableConfig.getDataParams);

            if (typeof tableConfig.filters !== 'undefined') {
              tableConfig.filters.forEach(function (filter) {
                if (getDataParams[filter.attr] && Array.isArray(getDataParams[filter.attr])) {
                  getDataParams[filter.attr] = getDataParams[filter.attr].concat(filter.value);
                } else {
                  getDataParams[filter.attr] = filter.value;
                }
              });
            }

            MainPreloader.show();

            $api.getAll({
              model: tableConfig.model,
              data: getDataParams,
              canceller: canceller.promise
            }).then(function (response) {
              $rootScope.$applyAsync(function () {
                tableConfig.items = response.data.items;
                tableConfig.total = response.data.total;
                tableConfig.pages = response.data.pages;
                tableConfig.page = response.data.page;
              });

              MainPreloader.hide();

              resolve();
            }, function (error) {
              if (error.message !== 'Request abort') {
                MainPreloader.hide();
              }

              reject(error);
            });
          } catch (error) {
            MainPreloader.hide();

            reject(error);
          }
        });

        promise.cancel = function () {
          canceller.resolve('api request canceled');
        };

        return promise;
      },
      defaultAppendData: function (tableConfig) {
        return new Promise(function (resolve, reject) {
          try {
            var getDataParams = angular.copy(tableConfig.getDataParams);

            tableConfig.filters.forEach(function (filter) {
              if (getDataParams[filter.attr] && Array.isArray(getDataParams[filter.attr])) {
                getDataParams[filter.attr] = getDataParams[filter.attr].concat(filter.value);
              } else {
                getDataParams[filter.attr] = filter.value;
              }
            });

            $api.getAll({
              model: tableConfig.model,
              data: getDataParams
            }).then(function (response) {
              $rootScope.$applyAsync(function () {
                tableConfig.items = tableConfig.items.concat(response.data.items);
                tableConfig.total = response.data.total;
                tableConfig.pages = response.data.pages;
                tableConfig.page = response.data.page;
              });

              resolve();
            });
          } catch (error) {
            reject(error);
          }
        });
      },
      initActiveTableConfig: function (config) {
        $rootScope.activeTableConfig = config;
      },
      hasPermissionTo: function (permission) {
        try {
          return $rootScope.appConfig.userPermissions.indexOf(permission) !== -1;
        } catch (error) {
          Raven.captureException(error);
        }

        return false;
      },
      hasPermissionToAddEdit: function (model, entityId) {
        try {
          if (entityId) {
            return $rootScope.appConfig.userPermissions.indexOf(model + ' edit') !== -1;
          }

          return $rootScope.appConfig.userPermissions.indexOf(model + ' add') !== -1;
        } catch (error) {
          Raven.captureException(error);
        }

        return false;
      },
      searchResource: function (model, needle) {
        return new Promise(function (resolve, reject) {
          $api.resource({
            model: model,
            data: {
              search: needle
            }
          }).then(function (response) {
            resolve(response.data);
          }, function (error) {
            Raven.captureException(error);

            reject(error);
          });
        });
      },
      colorCode: function (input) {
        if (input === null) {
          return '';
        }

        var str = JSON.stringify(input) + '-color';
        var hex = 0;

        for (var i = 0; i < str.length; i++) {
          hex = str.charCodeAt(i) + ((hex << 5) - hex);
        }

        var bigint = parseInt(hex, 16);
        var r = (bigint >> 16) & 255;
        var g = (bigint >> 8) & 255;
        var b = bigint & 255;

        return 'rgba(' + r + ',' + g + ',' + b + ', 0.20)';
      },
      shortenText: function (text, max) {
        if (text.length > max) {
          return text.substr(0, max - 3) + '...';
        }

        return text;
      }
    };

    try {
      $rootScope.getAppConfig().then(setAppTitle);
    } catch (error) {
      Raven.captureException(error);
    }
  }
})();
